import { render, staticRenderFns } from "./proProPage.vue?vue&type=template&id=1bcfd84e&scoped=true"
import script from "./proProPage.vue?vue&type=script&lang=js"
export * from "./proProPage.vue?vue&type=script&lang=js"
import style0 from "./proProPage.vue?vue&type=style&index=0&id=1bcfd84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfd84e",
  null
  
)

export default component.exports